import CampaignBlock from 'components/campaign-block/CampaignBlock';

import { ICampaignBlockList } from 'source/NFR.types';

const CampaignBlockList: React.FC<ICampaignBlockList> = ({ list }) => (
  <div className="campaign-block-list">
    {list?.map((campaignBlock, index) => (
      <CampaignBlock key={`${campaignBlock.title}-${index}`} {...campaignBlock} listLength={list.length} />
    ))}
  </div>
);

CampaignBlockList.displayName = 'CampaignBlockList';

export default CampaignBlockList;
